import { formatDateTimeReadable } from '@nemuru-eng/js-api-client';

import { ArticleTypeMap } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/maps/ArticleTypeMap';
import { StoredCart } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/types/StoredCart';

export class CartOption {
  public readonly totalCartValue: number;
  public readonly highestValueItemDescription: string | undefined;
  public readonly numberOfItemsInCart: number;
  public readonly dateOfCart: string;
  public readonly articleTypeIcon: string;

  public constructor(public readonly cart: StoredCart) {
    const highestValueItem = cart.cart.items.reduce(
      (max, item) => (item.price > max.price ? item : max),
      cart.cart.items[0],
    );
    this.totalCartValue = cart.cart.items.reduce((max, item) => (max = max + item.price), 0);
    this.highestValueItemDescription = highestValueItem.data.description;
    this.numberOfItemsInCart = cart.cart.items.length;
    this.dateOfCart = formatDateTimeReadable(cart.createdAt);
    this.articleTypeIcon = ArticleTypeMap.toIcon(highestValueItem?.data.type);
  }
}
